import { render, staticRenderFns } from "./OpenChannelPayments.vue?vue&type=template&id=59c30dfc&"
import script from "./OpenChannelPayments.vue?vue&type=script&lang=js&"
export * from "./OpenChannelPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports